export default __webpack_public_path__ + "static/media/iconguard.54bc7b01.png";